export const COLOR = {
  PRIMARY: "primary",
  PRIMARY_MAIN: "primary.main",
  SECONDARY: "secondary",
  INDIGO: "#5A67D8",
  PLACEHOLDER: "#a2a2a2",
  WARNING: "warning",
  WARNING_MAIN: "warning.main",
  ERROR: "error",
  ERROR_MAIN: "error.main",
  SUCCESS: "success",
  SUCCESS_MAIN: "success.main",
  ACTION_ACTIVE: "action.active",
  ACTION_DISABLED: "action.disabled",
  TEXT_PRIMARY: "text.primary",
  TEXT_SECONDARY: "text.secondary",
  TEXT_DISABLED: "text.disabled",
  BACKGROUND_DEFAULT: "background.default",
  BACKGROUND_PAPER: "background.paper",
  ACTION: "action",
  DISABLED: "disabled",
  DIVIDER: "divider",
  NAVIGATION: "#2E3E4F",
  PRIMARY_HOVER: "rgba(33, 150, 243, 0.04)",
  PRIMARY_SELECTED: "rgba(33, 150, 243, 0.08)",
} as const;

// Use this as the variant props value for the Typography component
export const TYPOGRAPHY = {
  BODY: "body1",
  BODY_SMALL: "body2",
  CAPTION: "caption", // 12px
  SUBTITLE: "subtitle1", // 16px
  SUBTITLE_SMALL: "subtitle2", // 14px
  HEADER_1: "h1",
  HEADER_2: "h2",
  HEADER_3: "h3",
  HEADER_4: "h4",
  HEADER_5: "h5",
  HEADER_6: "h6",
  HEADER_7: "h7",
} as const;
